export default "__VITE_ASSET__DJySUvPV__"